
import React, { useEffect } from 'react';
import defaultClasses from './passwordForgot.module.css';
import loginClasses from '../Login/login.module.css';
import { useStyle } from '../../utils/classify';

import { Form, message } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { EyeOutlined } from '@ant-design/icons';

import { useForgetPassword } from './usePasswordForgot';
import TextInput from '../../components/formDesign/TextInput/textInput';
import LandingWelcome from '../../components/LandingWelcome/landingWelcome';
import ButtonNode from '../../components/formDesign/ButtonNode/buttonNode';

const PasswordForgot = props => {

    const { formatMessage } = useIntl();
    const [messageApi, contextHolder] = message.useMessage();

    const talons = useForgetPassword();

    const {
        form,
        clientReady,
        loginLoading,
        onStartLogin,
        errorMsg,
        showErrorMsg,
        setShowErrorMsg,
        handleNavigateBack
    } = talons;

    useEffect(() => {
        if (showErrorMsg) {
            messageApi.open({
                type: 'error',
                content: errorMsg,
            });
            setShowErrorMsg(false);
        }

    }, [showErrorMsg, errorMsg, messageApi, setShowErrorMsg]);

    const classes = useStyle(loginClasses, defaultClasses, props.classes);

    return (
        <div className={classes.root}>
            {contextHolder}
            <aside className={classes.panel}>
                <div className={classes.panel_left}>
                    <LandingWelcome />
                </div>
                <div className={classes.panel_right}>
                    <div className={classes.right_box}>
                        <div className={classes.right_content}>
                            <h1>
                                <FormattedMessage id="passwordForget.passwordReset" defaultMessage={"Password Reset"} />
                            </h1>
                            <div className={classes.right_top_create}>
                                <FormattedMessage id="passwordForget.panelRightSpan" defaultMessage={"Don’t have an account?"} />
                            </div>
                            <Form className={classes.form} form={form} name="login_form" onFinish={onStartLogin} layout='vertical'>
                                <TextInput
                                    name="email"
                                    rules={[{
                                        required: true,
                                        message: formatMessage({
                                            id: "form.isRequired",
                                            defaultMessage: "{name} is required!"
                                        }, {
                                            name: formatMessage({
                                                id: "form.email",
                                                defaultMessage: "email"
                                            })
                                        })
                                    }]}

                                    label={formatMessage({
                                        id: "form.email",
                                        defaultMessage: "Email"
                                    })}
                                    placeholder={formatMessage({
                                        id: "form.placeholder",
                                        defaultMessage: "Please enter {name} "
                                    }, {
                                        name: formatMessage({
                                            id: "form.emailPlaceholder",
                                            defaultMessage: "email"
                                        })
                                    })}
                                />

                                <Form.Item shouldUpdate>
                                    {() => (
                                        <ButtonNode
                                            type="primary"
                                            htmlType="submit"
                                            disabled={
                                                !clientReady ||
                                                !!form.getFieldsError().filter(({ errors }) => errors.length).length
                                            }
                                            loading={loginLoading}
                                            style={{ width: '100%' }}
                                        >
                                            <FormattedMessage id="passwordForget.passwordReset" defaultMessage={"Password Reset"} />
                                        </ButtonNode>
                                    )}
                                </Form.Item>

                                <div className={classes.form_other}>
                                    <ButtonNode
                                        type="link"
                                    >
                                        <FormattedMessage id="passwordForget.rememberedPassword" defaultMessage={"Remembered your Password?"} />
                                    </ButtonNode>
                                </div>

                                <div className={classes.form_other}>
                                    <ButtonNode
                                        type="default"
                                        onClick={handleNavigateBack}
                                    >
                                        <FormattedMessage id="passwordForget.navigateBack" defaultMessage={"Back to Sign In"} />
                                    </ButtonNode>
                                </div>
                            </Form>
                        </div>
                        {/* <div className={classes.right_bottom}>
                            <FormattedMessage id="global.copyright " defaultMessage={"Copyright @ 2024 BCNetcom. All Rights Reserved"} />
                        </div> */}
                    </div>
                </div>
            </aside>
        </div>
    )
}

export default PasswordForgot;